























































































































































































































































































































// tslint:disable
import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwTable, TableEntry, TableColumnConfig, TableEntryGroup, ColumnsAdjustRequestData } from '@libs-uuif/shared/sw-table';
import { UserList, UserListResponse, UserListContent, UserModalType, AccessList } from './types';
import { ApiError } from '@sonicwall/unified-ui-framework/src/shared/api-service';
import { InfoState } from '@/core/core.store';
import { CreateElement, VNode } from 'vue';
import UserModal from './userModal.vue';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import  { MswApiService } from '@/shared/msw-api-service';
import { SwDatetimePicker, DateTimePickerConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { ContentToolbarExpandFilterBlock } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwActionBar, SwActionBarItem } from '@sonicwall/unified-ui-framework/src/shared/sw-action-bar';
import { SwTextarea } from '@libs-uuif/shared/sw-textfield';
import { currentUserKey } from '@/shared/msw-constants';
import { MSSPPrefilterResponseType } from './userGroupTypes';
import { envCongif } from '@/shared/env.config';
import { TableEntrySelectingEventData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import SuperAdminModal from '@/shared/addOrUpdateSuperAdminModal/addOrUpdateSuperAdminModal.vue';

const cssPrefix = 'access-mgmt-user-list';
@Component({
  components: {
    ...UUIFComponents,
    SwSelect,
    UserModal,
    SwActionBar,
    SwActionBarItem,
    SwDatetimePicker,
    SwTextarea,
    SuperAdminModal,
  },
})
export default class AccessMgmtUserList extends SwExtendedVue {
  cssPrefix = cssPrefix;
  adjustedColumns: ColumnsAdjustRequestData = {};
  expandVisible = false;
  searchUserList: string = '';
  mustIncludeColumnKeys: string[] = ['selection', 'indexVal', 'name', 'email', 'type', 'userGroupVal', 'organisation', 'actions'];
  customColumnConfig: TableColumnConfig[] = [];
  userTableData: TableEntry[] = [];
  userModalTypeProp: 'add' | 'edit' = 'add';
  userModalShowProp = false;
  userDetails: any = {};
  openApiKeyDetails: boolean = false;
  showDetails: boolean = false;
  showRevoke: boolean = false;
  showGrant: boolean = false;
  associatedUserGroups: any = '';
  showDelete: boolean = false;
  generatedApiKey: string = '';
  showAPIkey: boolean = false;
  generatedMsg: string = '';
  showGeneratedKey: boolean = false;
  addOrUpdateSuperAdminModal: boolean = false;
  apiKey: any = {
    userType: 'Employee',
    userEmail: '',
    desc: '',
    ip: '',
    expDate: '',
  };
  dataToDisplay: any = {};
  defaultPropData: UserModalType = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    selectedMssp: '',
    selectedContactType: '',
    userGroup: [],
  };
  selectedTableRows:any[] = [];
  selectedUsernames:any[] = [];
  userModalDataProp: UserModalType = this.defaultPropData;
  showHyperLink: boolean = false;
  selectedType: any = [];
  selectedAccessScope: any = [];
  selectedGroup: any = [];
  userList:any = [];
  tempUserList: any = [];
  msspAccessListOptions: SelectOption[] = [];
  openNewUserModal = false;
  contactIdTobDeleted = '';
  newMsspIdAfterDelete = '';
  msspDropDownVal: SelectOption[] = [];
  msspPrefilterResponseFromApi: MSSPPrefilterResponseType = {
    content: {
      MSSPs: [],
      Products: [],
      ProvisionMSSP: '',
      ProvisionTenant: '',
      ProvisionProduct: '',
      ProvisionTenantMsg: '',
      ProvisionProductMsg: '',
      MSSPTier: '',
      orgID: ''
    },
    operationStatus: '',
    msgCode: '',
    msgId: '',
    msgDesc: '',
  };
  userSettings: UserListContent = {
    userList: [],
    userListCount: '',
    flexspendRole: '',
    showDeleteUserIcon: false,
    showTFAModeUserIcon: false,
    userGroupNames: '',
    showGenerateAPIKeyIcon: false,
    showViewAPIKeyIcon: false,
    showInviteUserIcon: false,
    showOrgBasedIcon: '',
    orgBasedsuperAdminButtonText: '',
    maxSuperAdminCount: 0,
    // showIDPUserIcon: false,
    flexspendAccessList: [],
    msspAccessList: [],
  };
  showUpdateIdpStatus: boolean = false;

  columnConfig: TableColumnConfig[] = [
    {
      key: 'selection',
      type: 'selection',
    },
    {
      key : 'indexVal',
      type: 'index',
    },
    {
      key: 'name',
      dataKey: 'name',
      title: String(this.$t('accessMgmt.name')),
      width: 150,
    },
    {
      key: 'email',
      dataKey: 'email',
      title: String(this.$t('accessMgmt.email')),
      width: 230,
    },
    {
      key: 'type',
      dataKey: 'type',
      title: String(this.$t('accessMgmt.type')),
      width: 100,
    },
    {
      key: 'accessScope',
      dataKey: 'accessScope',
      title: String(this.$t('accessMgmt.accessScope')),
      width: 130,
    },
    {
      key: 'userGroupVal',
      dataKey: 'userGroupVal',
      title: String(this.$t('accessMgmt.usrGrp')),
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry }) => {
        return (
          <div onClick={() => { this.onUserGroupClick(data.entry.userGroupVal); }} > {data.entry.userGroupVal}
          </div>
        ) as VNode;
      },
    },
    {
      key: 'organisation',
      dataKey: 'organisation',
      title:  String(this.$t('accessMgmt.org')),
      width: 250,
    },
    {
      key: 'msspName',
      dataKey: 'msspName',
      title: String(this.$t('accessMgmt.msspName')),
      width: 250,
    },
    {
      key: 'msspPermission',
      dataKey: 'Mssp Permission',
      title: String(this.$t('accessMgmt.msspPermission')),
      render: this.userPermissionRender,
    },
    {
      key: 'actions',
      title: 'Actions',
      // render: this.actionUserListRender,
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => this.actionsColumnRenderer(h, data),
      width: 150,
    },
  ];

  singlePickerConfig: DateTimePickerConfig = {
    placeholder: String(this.$t('accessMgmt.pick')),
    dateFormat: 'DD/MM/YYYY',
    selectableDatesRange: { startDate: this.getStartDate(), endDate: this.getEndDate() },
    hidePreAndNextMonthDates: true,
  };

  get TFAUsers() {
    const selectedTFAUsers = this.selectedTableRows.filter((user: any) => {
      return user.showTFAModeUserIcon === 'YES';
    });
    return selectedTFAUsers;
  }

  get getUserGrpName() {
    let formatedUserGrpName = '';
    if (this.associatedUserGroups && this.associatedUserGroups.length > 34) formatedUserGrpName = `${this.associatedUserGroups.slice(0, 34)}....`;
    else formatedUserGrpName = this.associatedUserGroups;
    return formatedUserGrpName;
  }

  get IDPUsers() {
    const selectedIDPUsers = this.selectedTableRows.filter((user: any) => {
      return user.showIDPUserIcon === 'YES';
    });
    return selectedIDPUsers;
  }

  actionsColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    return (
      <div>
        {
          this.userSettings.showDeleteUserIcon &&
          <span style='margin-left: 15px'>
            <sw-icon
              name='trash'
              size={16}
              v-tooltip={{ content: String(this.$t('accessMgmt.deleteUser')), placement: 'top', compact: true }}
              nativeOn-click={() => this.deleteUser(data.entry)}
            >
            </sw-icon>
          </span>
        }
        {
          (data.entry.employee === 'YES' && data.entry.showTFAModeUserIcon === 'YES') &&
          (data.entry.tfaStatus === 'YES' || data.entry.tfaStatus === 'NO' || data.entry.tfaStatus === 'APP') &&
          <span style='margin-left: 15px'>
            <sw-icon
              name={data.entry.tfaStatus === 'YES' || data.entry.tfaStatus === 'APP' ? 'locked' : 'unlocked'}
              size={16}
              v-tooltip={{ content: data.entry.tfaStatus === 'YES' ? String(this.$t('accessMgmt.tfaEmail')) : data.entry.tfaStatus === 'APP' ? String(this.$t('accessMgmt.tfaApp')) : String(this.$t('accessMgmt.tfaOff')), placement: 'top', compact: true }}
              nativeOn-click={() => data.entry.tfaStatus !== 'APP' && this.updateTFA(data.entry, data.entry.tfaStatus === 'YES' ? 'OFF' : 'ON', 'single')}
            >
            </sw-icon>
          </span>
        }
        {
          (data.entry.showViewUserAPIKey === 'YES') &&
          <span style='margin-left: 15px'>
            <span class="action_key_icon" onClick={() => this.viewOrRevokeOrGrantApi(data.entry)}  v-tooltip={{ content: String(this.$t('accessMgmt.viewMan')), placement: 'top', compact: true }}></span>
          </span>
        }
        {
          (data.entry.employee === 'YES' && data.entry.showIDPUserIcon === 'YES') &&
          (data.entry.idpStatus === 'YES' || data.entry.idpStatus === 'NO') &&
          <span style='margin-left: 15px'>
            <sw-icon
              name={data.entry.idpStatus === 'YES' ? 'user' : 'user-lock'}
              size={16}
              v-tooltip={{content: data.entry.idpStatus === 'YES' ? String(this.$t('accessMgmt.idpEnabled')) : String(this.$t('accessMgmt.nidpEnabled')) , placement: 'top', compact: true }}
              nativeOn-click={() => this.updateIDP(data.entry, data.entry.tfaStatus === 'YES' ? 'OFF' : 'ON', 'single')}
            >
            </sw-icon>
          </span>
        }
      </div>
    ) as VNode;
  }
  // }

  get getTitle() {
    // tslint:disable-next-line
    if (this.showDetails) return String(this.$t('accessMgmt.api'));
    else return String(this.$t('accessMgmt.genApi'));
  }

  get getGeneratedKey() {
    if (this.showAPIkey) return this.generatedApiKey;
    else {
      const key = this.generatedApiKey.substr(this.generatedApiKey.length - 4);
      return key;
    }
  }

  viewOrRevokeOrGrantApi(data: any, mode: string = "GET") {
    this.showHyperLink = true;
    this.$store.commit('startLoading');
    let reqBody: any = {
      mode,
      username: data.userName,
      sourceName: "MSSP",
    };
    MswApiService.createCustomer.viewOrRevokeOrGrant(reqBody)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.userDetails = data;
        if (mode === 'GET') {
          this.dataToDisplay = resp.content;
          this.dataToDisplay.email = data.email;
          if (data.userGroupVal !== undefined || data.userGroupVal !== '') this.dataToDisplay.userGrp = data.userGroupVal;
          this.showDetails = true;
          ((resp.content.status === 'ACTIVE' || resp.content.status === 'EXPIRED') && data.userName === JSON.parse((localStorage as any).getItem('currentUser')).userId) ?
          this.showDelete = true : this.showDelete = false;
          (resp.content.status === 'ACTIVE' && data.userName !== JSON.parse((localStorage as any).getItem('currentUser')).userId) ?
          this.showRevoke = true : this.showRevoke = false;
          (resp.content.status === 'REVOKED' && data.userName !== JSON.parse((localStorage as any).getItem('currentUser')).userId) ?
          this.showGrant = true : this.showGrant = false;
          this.openApiKeyDetails = true;
        } else {
          this.openApiKeyDetails = false;
          this.formatUserTableData();
        }
        if (resp.msgCode === 'MSWAPP:APIKEYDGRANTSUCCESS' || resp.msgCode === 'MSWAPP:APIKEYREVOKESUCCESS') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }

  getStartDate() {
    const today = new Date();
    const dd = String(today.getDate())
    .padStart(2, '0');
    const mm = String(today.getMonth() + 1)
              .padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  getEndDate() {
    let oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    const dd2 = String(oneYearFromNow.getDate())
    .padStart(2, '0');
    const mm2 = String(oneYearFromNow.getMonth() + 1)
              .padStart(2, '0'); // January is 0!
    const yyyy2 = oneYearFromNow.getFullYear();
    return `${dd2}/${mm2}/${yyyy2}`;
  }

  showFormToGenerateKey() {
    Object.keys(this.apiKey).forEach((item: any) => {
      this.apiKey[item] = '';
    })
    this.apiKey.userType = 'Employee';
    this.apiKey.userEmail = JSON.parse((localStorage as any).getItem('currentUser')).email;
    this.apiKey.expDate = this.getEndDate();
    this.showGeneratedKey = false;
    this.showHyperLink = false;
    this.showDetails = false;
    this.showGrant = false;
    this.showDelete = false;
    this.showRevoke = false;
    this.openApiKeyDetails = true;
  }

  openAPIdocumentation() {
    const apiUrl: any = envCongif.api_url;
    const url = new URL(apiUrl);
    const swaggerUrl = `${url.protocol}//${url.hostname}`;
    window.open(`${swaggerUrl}/mssp.html`, '_blank');
  }

  showKeyForLoggedInUser() {
    try {
      const details = {
        userName: JSON.parse((localStorage as any).getItem(currentUserKey)).userId,
        email: JSON.parse((localStorage as any).getItem(currentUserKey)).email,
      };
      this.viewOrRevokeOrGrantApi(details);
    } catch(error) {
      console.error(error);
    }
  }

  revokeConfirmation(payload: any) {
    confirmService.confirm({
      status: 'informational',
      title: String(this.$t('accessMgmt.confirmation')),
      message: String(this.$t('accessMgmt.removeKey')),
      buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.ok')) }],
    })
    .then((key) => {
      if (key === 'ok') this.viewOrRevokeOrGrantApi(payload, 'REVOKE');
    });
  }

  grantConfirmation(payload: any) {
    confirmService.confirm({
      status: 'informational',
      title: String(this.$t('accessMgmt.confirmation')),
      message: String(this.$t('accessMgmt.keyBack')),
      buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.ok')) }],
    })
    .then((key) => {
      if (key === 'ok') this.viewOrRevokeOrGrantApi(payload, 'GRANT');
    });
  }

  deleteConfirmation() {
    confirmService.confirm({
      status: 'informational',
      title: String(this.$t('accessMgmt.confirmation')),
      message: String(this.$t('accessMgmt.deleteKey')),
      buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.ok')) }],
    })
    .then((key) => {
      if (key === 'ok') this.deleteApiKey();
    });
  }

  generateApiKeyOrClose(str: any) {
    if (str === 'Confirm') {
      if (this.apiKey.desc.length < 100) {
        const formattedDate = this.apiKey.expDate.split('/');
        const reqBody = {
          mode: "INSERT",
          description: this.apiKey.desc,
          ipAddress: this.apiKey.ip,
          sourceName: "MSSP",
          expDate: `${formattedDate[1]}/${formattedDate[0]}/${formattedDate[2]}`,
        }
        MswApiService.createCustomer.viewOrRevokeOrGrant(reqBody)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:APIKEYCREATESUCCESS') {
            this.generatedApiKey = resp.content.apiKey;
            this.generatedMsg = resp.msgDesc;
            this.showGeneratedKey = true;
            this.showHyperLink = true;
          } else {
            const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
            this.$store.commit('enqueueMessage', message);
          }
        });
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: String(this.$t('accessMgmt.desc')) };
        this.$store.commit('enqueueMessage', message);
      }
    } else {
      this.openApiKeyDetails = false;
      this.showGeneratedKey = false;
      this.showAPIkey = false;
      this.formatUserTableData();
    }
  }

  closeAPImodal() {
    this.openApiKeyDetails = false;
    if (this.showGeneratedKey){
      this.formatUserTableData();
      this.showGeneratedKey = false;
    }
  }

  copyToClipBoard() {
    window.navigator.clipboard.writeText(this.generatedApiKey);
    this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: String(this.$t('accessMgmt.copied')) });
  }

  deleteApiKey() {
    const reqBody = {
      mode: "DELETE",
      sourceName: "MSSP",
    }
    MswApiService.createCustomer.viewOrRevokeOrGrant(reqBody)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:APIKEYDELETESUCCESS') {
        this.openApiKeyDetails = false;
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.formatUserTableData();
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }

  deleteUser(user: any) {
    confirmService.confirm({
      status: 'informational',
      title: String(this.$t('accessMgmt.confirmation')),
      message: String(this.$t('accessMgmt.suretoDelete')),
      buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.ok')) }],
    })
    .then((key) => {
      if (key === 'ok') {
        this.$store.commit('startLoading');
        const deleteData = {
          contactId: user.contactId,
          isFromMSSP: 'YES',
        };
        MswApiService.createCustomer.deleteContact(deleteData)
        .then((resp: any) =>  {
          if (resp.operationStatus === 'NOK') {
            // this.$store.commit('stopLoading');
            const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
            this.$store.commit('enqueueMessage', message);
            if (resp.msgCode === 'MSWAPP:MSSPASSIGNOTHERMSSP') {
              this.deleteWithNewMsspId(user.contactId);
            }
          } else {
            // this.$store.commit('stopLoading');
            const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
            this.$store.commit('enqueueMessage', message);
          }
          this.intialisePage();
          this.$store.commit('stopLoading');
        })
        .catch(() => {
          this.$store.commit('stopLoading');
        });
      }
    });
  }

  deleteUsers(user: any) {
    this.selectedUsernames = this.selectedTableRows.map((user) => { return user?.contactId });
    this.$store.commit('startLoading');
    const deleteData = {
      contactId: [...this.selectedUsernames],
      isFromMSSP: 'YES',
    };
    MswApiService.createCustomer.deleteContact(deleteData)
    .then((resp: any) =>  {
      if (resp.operationStatus === 'NOK') {
        // this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
        if (resp.msgCode === 'MSWAPP:MSSPASSIGNOTHERMSSP') {
          this.deleteWithNewMsspId(user.contactId);
        }
      } else {
        // this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
      this.intialisePage();
      this.$store.commit('stopLoading');
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  deleteWithNewMsspId(contactID: string) {
    this.openNewUserModal = true;
    this.contactIdTobDeleted = contactID;
  }

  updateTFA(user: any, mode: any, type: any) {
    if (type === 'multiple') {
      this.selectedUsernames = this.selectedTableRows.map((user) => { return user.userName; });
      const payload = {
        mode,
        usernames: this.selectedUsernames,
      };
      this.$store.dispatch('AccessManagementStoreModule/updateTFA', payload)
      .then((resp) => {
        if (resp.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.intialisePage();
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      });
    } else {9
      confirmService.confirm({
        status: 'informational',
        title: String(this.$t('accessMgmt.confirmation')),
        message: String(this.$t('accessMgmt.turn')).concat( mode === 'ON' ?
        String(this.$t('accessMgmt.on')) : String(this.$t('accessMgmt.off')), String(this.$t('accessMgmt.tfaFr')) ,(user.email)),
        buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.ok')) }],
      })
      .then((key) => {
        if (key === 'ok') {
          this.$store.commit('startLoading');
          const payload = {
            mode,
            usernames: [user.userName],
          };
          this.$store.dispatch('AccessManagementStoreModule/updateTFA', payload)
          .then((resp: any) =>  {
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK') {
              const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
              this.$store.commit('enqueueMessage', message);
              this.intialisePage();
            } else {
              const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
              this.$store.commit('enqueueMessage', message);
            }
          })
          .catch(() => {
            this.$store.commit('stopLoading');
          });
        }
      });
    }
  }

  onColumnSelectionKeys(values: Array<string>) {
    const filterToBeSaved: any = {
      selectedColumns: [...values],
    };
    const formattedFilterObj = JSON.stringify(filterToBeSaved);
    MswApiService.tenant.postFilterPreference(formattedFilterObj, 'MSSPACMGMT')
      .then((response: any) => {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: response.msgDesc });
        this.selectedColumnKeys = [...values];
      })
      .catch((errorResponse: any) => {
        console.error(errorResponse);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  updateIDP(user: any, mode: any, type: any) {
    if (type === 'multiple') {
      this.selectedUsernames = this.selectedTableRows.map((user) => { return user.userName; });
      const payload = {
        mode,
        usernames: this.selectedUsernames,
      };
      this.$store.dispatch('AccessManagementStoreModule/updateIDP', payload)
      .then((resp) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.intialisePage();
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      });
    } else {
      confirmService.confirm({
        status: 'informational',
        title: String(this.$t('accessMgmt.confirmation')),
        message: String(this.$t('accessMgmt.turn')).concat( mode === 'ON' ?
        String(this.$t('accessMgmt.on')) : String(this.$t('accessMgmt.off')), String(this.$t('accessMgmt.idpFr')) ,(user.email)),
        buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.ok')) }],
      })
      .then((key) => {
        if (key === 'ok') {
          this.$store.commit('startLoading');
          const payload = {
            mode,
            usernames: [user.userName],
          };
          this.$store.dispatch('AccessManagementStoreModule/updateIDP', payload)
          .then((resp: any) =>  {
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK') {
              const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
              this.$store.commit('enqueueMessage', message);
              this.intialisePage();
            } else {
              const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
              this.$store.commit('enqueueMessage', message);
            }
          })
          .catch(() => {
            this.$store.commit('stopLoading');
          });
        }
      });
    }
  }

  clearSelectedRows() {
    this.selectedTableRows = [];
    const vm = this.$refs.usersTable as SwTable;
    if (vm) {
      vm.selectedSet.clear();
    }
    this.userTableData = this.userTableData.slice();
  }

  onEntrySelecting(data: TableEntrySelectingEventData) {
    const selectedKey: any = data.entryKey;
    if (data.selecting) {
      this.selectedTableRows.push((this.userTableData[Number(selectedKey)]));
      if (this.selectedTableRows.length > 0 && this.userTableData[Number(selectedKey)].idpStatus === 'N/A' && !this.showUpdateIdpStatus) {
        this.showUpdateIdpStatus = true;
      } else {
        this.showUpdateIdpStatus = false;
      }
    } else {
      const arrIndexes = this.selectedTableRows.map((user) => { return user._key; });
      const removeIndex = arrIndexes.indexOf(Number(selectedKey));
      this.selectedTableRows.splice(removeIndex, 1);
    }
  }

  /* tslint:disable-next-line */
  userPermissionRender(h: CreateElement, data: { entry: TableEntry }): VNode {
    return (
        <SwSelect props-name={'permissionSelect'}
          props-options={this.msspAccessListOptions}
          props-value={data.entry.msspChoiceId}
          props-full={true}
          props-disabled={data.entry.msspRoleEditable !== 'TRUE'}
          on-change={(val: string) => { this.updatePermissionOfUser(data.entry, val); }}
      ></SwSelect>
    ) as VNode;
  }

  async updatePermissionOfUser(user: TableEntry, val: string) {
    const dataToBeUpdated = {
      partyid: user.partyId,
      choiceid: val,
    };
    try {
      this.$store.commit('startLoading');
      await this.updateMsspAPiCall(dataToBeUpdated);
      await this.formatUserTableData();
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  updateMsspAPiCall(dataToBeUpdated: any) {
    return new Promise((res, rej) => {
      MswApiService.userListSection.updatePermission(dataToBeUpdated)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        }
        res(true);
      })
      .catch(() => {
        rej(true);
      });
    });
  }

  onUserGroupClick(userGroup: string) {
    this.$emit('routeToUsergGroup', userGroup);
  }

  selectedColumnKeys: string[] = [];

  /* tslint:disable-next-line */
  actionUserListRender(h: CreateElement, data: { entry: TableEntry }): VNode {
    return (<div>
        <div class={['sw-flexbox__flex', 'sw-flexbox', 'sw-flexbox--center-items']}>
          <SwIconButton name="deleteUserIcon" icon="trash" nativeOn-click={() => {
            confirmService.confirm({
              status: 'informational',
              title: String(this.$t('accessMgmt.confirmation')),
              message: String(this.$t('accessMgmt.suretoDelete')),
              buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.ok')) }],
            })
            .then((key) => {
              if (key === 'ok') {
                this.$store.commit('startLoading');
                const deleteData = {
                  contactId: data.entry.contactId,
                };
                MswApiService.createCustomer.deleteContact(deleteData)
                .then((resp: any) =>  {
                  if (resp.operationStatus === 'NOK') {
                    // this.$store.commit('stopLoading');
                    const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
                    this.$store.commit('enqueueMessage', message);
                    if (resp.msgCode === 'MSWAPP:MSSPASSIGNOTHERMSSP') {
                      this.deleteWithNewMsspId(data.entry.contactId);
                    }
                  } else {
                    // this.$store.commit('stopLoading');
                    const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
                    this.$store.commit('enqueueMessage', message);
                  }
                  this.intialisePage();
                  this.$store.commit('stopLoading');
                })
                .catch(() => {
                  this.$store.commit('stopLoading');
                });
              }
            });
          }
          }/>
        </div>
    </div>) as VNode;
  }

  onCloseDeleteContactModal() {
    this.openNewUserModal = false;
    this.contactIdTobDeleted = '';
  }

  onClickSave() {
    const deleteData = {
      contactId: this.contactIdTobDeleted,
      newMsspEmail: this.newMsspIdAfterDelete,
      isFromMSSP: 'YES',
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.deleteContact(deleteData)
    .then((resp: any) =>  {
      if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
      } else {
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
      this.intialisePage();
      this.$store.commit('stopLoading');
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
    this.onCloseDeleteContactModal();
  }

  filterBlockGrid: ContentToolbarExpandFilterBlock[][] = [
    [
      { title: String(this.$t('accessMgmt.type1')), content: this.typeFilter, width: 250 },
      { title: String(this.$t('accessMgmt.accessScope1')), content: this.accessScopeFilter, width: 250 },
      { title: String(this.$t('accessMgmt.usrGrp1')), content: this.userGroupFilter, width: 270 },
    ],
  ];

  searchUserListTable() {
    if (!this.searchUserList) {
      this.applyFilters();
      return true;
    }
    const obj = this.searchUserList.toString()
    .toLocaleLowerCase();
    this.userTableData = this.tempUserList.filter((row: any) => {
      let flag = false;
      for (const key in row) {
        if (Object.prototype.hasOwnProperty.call(row, key)) {
          flag = row[key] ? row[key].toString()
          .toLocaleLowerCase()
          .includes(obj) : false;
          if (flag) {
            return flag;
          }
        }
      }
      return false;
    });
  }

  get userListColumnConfig (): TableColumnConfig[] {
    return this.columnConfig.filter(col => (this.selectedColumnKeys.includes(col.key) || this.defaultColumnList(col.key)));
  }

  get getFilteredData(): TableEntry[] | TableEntryGroup[] {
    return this.userTableData;
  }
  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  defaultColumnList(columnKey: string) {
    return this.mustIncludeColumnKeys.includes(columnKey);
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  getSelectedColumnList() {
    return new Promise(async (res) => {
      try {
        this.$store.commit('startLoading');
        const response = await  MswApiService.tenant.getMsspPreferenceFilter('MSSPACMGMT');
        if (response && response.preferenceData) {
          const decodedData = JSON.parse(response.preferenceData) || {};
          this.selectedColumnKeys = this.selectedColumnKeys.concat(decodedData.selectedColumns);
        }
      } catch (e) {
        console.error(e);
      }
      // } finally {
      //   this.$store.commit('stopLoading');
      // }
      // Persisted column config might be fetched from API later so we can wrap it in promise for now
      const tempData: TableColumnConfig[] = [];
      this.columnConfig.forEach((columnEntry: TableColumnConfig) => {
        if (!this.mustIncludeColumnKeys.includes(columnEntry.key)) { // do not include columns that should always be visible
          tempData.push(columnEntry);
        }
      });
      // this.selectedColumnKeys = tempData;
      this.customColumnConfig = tempData;
      res(true);
    });
  }

  formatUserTableData() {
    this.$store.commit('startLoading');
    return new Promise((res) => {
      MswApiService.userListSection.getUserList()
      .then((userListData : UserListResponse) => {
        this.associatedUserGroups = userListData.content?.userGroupNames;
        this.$store.commit('stopLoading');
        this.userSettings.showDeleteUserIcon = userListData?.content?.showDeleteUserIcon;
        this.userSettings.showTFAModeUserIcon = userListData?.content?.showTFAModeUserIcon;
        this.userSettings.showGenerateAPIKeyIcon = userListData ? userListData.content ? userListData.content.showGenerateAPIKeyIcon : false : false;
        this.userSettings.showViewAPIKeyIcon = userListData ? userListData.content ? userListData.content.showViewAPIKeyIcon : false : false;
        this.userSettings.showInviteUserIcon = userListData ? userListData.content ? userListData.content.showInviteUserIcon : false : false;
        // this.userSettings.showIDPUserIcon = userListData?.content?.showIDPUserIcon;
        this.userSettings.showOrgBasedIcon = userListData?.content?.showOrgBasedIcon;
        this.userSettings.orgBasedsuperAdminButtonText = userListData?.content?.orgBasedsuperAdminButtonText;
        this.$store.commit('AccessManagementStoreModule/setMaxSuperAdminCount', userListData?.content?.maxSuperAdminCount);
        const userListApiData: UserList[] = userListData.content ? userListData.content.userList ? userListData.content.userList : [] : [];
        const tempColumnData: TableEntry[] = [];
        this.msspDropDownVal = [];
        userListApiData.forEach((userEntry: UserList, index) => {
          tempColumnData.push({
            _key: index.toString(),
            _selectable: userEntry?.contactType === 'Employee' && userEntry?.tfaStatus !== 'APP',
            name: userEntry.fullName,
            email: userEntry.emailAddress,
            type: userEntry.contactType,
            accessScope: userEntry.accessScope,
            userGroupVal: userEntry.userGroup && userEntry.userGroup.length > 1 ? userEntry.associatedUserGroups :
            userEntry.userGroup.length === 0 ?  '' : userEntry.userGroup[0].userGroupName,
            userGroup: userEntry.userGroup ? userEntry.userGroup : [],
            firstname: userEntry.firstName,
            lastname: userEntry.lastName,
            contactId: userEntry.contactId,
            organisation: userEntry.companyName,
            msspChoiceId: userEntry.msspChoiceId,
            msspRoleEditable: userEntry.msspRoleEditable,
            partyId: userEntry.partyId,
            employee: userEntry.employee,
            tfaStatus: userEntry.tfaStatus,
            idpStatus: userEntry.idpStatus,
            showIDPUserIcon: userEntry.showIDPUserIcon,
            showTFAModeUserIcon: userEntry.showTFAModeUserIcon,
            showViewUserAPIKey: userEntry.showViewUserAPIKey,
            userName: userEntry.userName,
            msspName: userEntry.msspName,
          });
          if (userEntry.contactId !== this.contactIdTobDeleted && userEntry.contactType === 'Employee') {
            this.msspDropDownVal.push({
              id: userEntry.emailAddress,
              value: userEntry.emailAddress,
              label: userEntry.emailAddress,
            });
            this.newMsspIdAfterDelete = this.msspDropDownVal[0] ? this.msspDropDownVal[0].id : '';
          }
        });
        const tempObj: any = localStorage.getItem(currentUserKey);
        const userInfoObtained: any = JSON.parse(tempObj);
        const loggedInUserAlreadyPresent: boolean = this.msspDropDownVal.findIndex((user: SelectOption) => {
          return user.id.toLowerCase() === userInfoObtained.email.toLowerCase();
        }) > -1;
        if (!loggedInUserAlreadyPresent) {
          this.msspDropDownVal.push({
            id: userInfoObtained.email,
            value: userInfoObtained.email,
            label: userInfoObtained.email,
          });
        }
        this.userTableData = tempColumnData;
        this.userList = tempColumnData;
        this.tempUserList = tempColumnData;
        if (userListData.content.msspAccessList) {
          this.msspAccessListOptions = userListData.content.msspAccessList.map((ele: AccessList) => {
            return {
              id: ele.choiceId,
              label: ele.choiceName,
              value: ele.choiceId,
            };
          });
        }
        res(true);
      })
      .catch((error: ApiError) => {
        const message: InfoState = { infoType: 'high', infoMsg: error.message || String(this.$t('accessMgmt.unknown')) };
        this.$store.commit('displayMessage', message);
        res(true);
      });
    });
  }

  async intialisePage() {
    try {
      this.$store.commit('startLoading');
      await this.getSelectedColumnList();
      await this.formatUserTableData();
      await this.fetchMsspPrefilterList();
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  async fetchMsspPrefilterList() {
    return new Promise((res: any) => {
      MswApiService.usageReport.getMsspList()
      .then((resp: MSSPPrefilterResponseType) => {
        this.msspPrefilterResponseFromApi = resp;
        if (this.msspPrefilterResponseFromApi.content.pendoEnabled &&
          this.msspPrefilterResponseFromApi.content.pendoEnabled === 'YES' &&
          this.msspPrefilterResponseFromApi.content.showPendo && this.msspPrefilterResponseFromApi.content.showPendo !== 'YES') {
          this.startPendoAnalytics();
        }
        res(true);
      })
      .catch(() => {
        res(true);
      });
    });
  }

  inviteNewUser() {
    this.userModalShowProp = true;
    this.userModalTypeProp = 'add';
  }

  openAddOrUpdateSuperAdminModal() {
    this.$store.dispatch('AccessManagementStoreModule/getAdminList')
    .then((res: any) => {
      this.$store.commit('stopLoading');
      if (res?.operationStatus === 'OK') {
        this.$store.commit('AccessManagementStoreModule/setAdminList', res?.adminList || []);
        this.addOrUpdateSuperAdminModal = true;
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res?.msgDesc });
      }
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  closeAddOrUpdateSuperAdminModal(loadPage: boolean) {
    this.addOrUpdateSuperAdminModal = false;
    if (loadPage) {
      this.intialisePage();
    }
  }

  closeModal(loadPage: boolean) {
    this.userModalShowProp = false;
    if (loadPage) {
      this.intialisePage();
    }
  }

  async mounted() {
    // (window as any).pendo.initialize();
    await this.intialisePage();
  }

  applyFilters() {
    let data: any = this.userList;
    if (this.selectedType.length > 0) {
      const entry = data.filter((item: any) => {
        return this.selectedType.includes(item.type);
      });
      data = entry;
    }
    if (this.selectedAccessScope.length > 0) {
      const entry = data.filter((item: any) => {
        return this.selectedAccessScope.includes(item.accessScope);
      });
      data = entry;
    }
    if (this.selectedGroup.length > 0) {
      const entry = data.filter((item: any) => {
        return this.selectedGroup.includes(item.userGroupVal);
      });
      data = entry;
    }
    this.userTableData = data;
    this.tempUserList = data;
    this.expandVisible = false;
  }

  /* tslint:disable-next-line */
  typeFilter(h: CreateElement): VNode   {// eslint-disable-line  // tslint:disable-line
    const type:any  = [];
    this.userList.map((obj:any) => {
      if (!type.includes(obj.type)) {
        type.push(obj.type);
      }
    });
    const typeData:any = [...type];
    return (
      typeData.map((obj:any) => {
        return (
        <div>
        <SwCheckbox name={'type'}
        props-value={ obj }
        props-checked={this.selectedType.includes(obj)} with-margin
        on-change={() => {
          if (this.selectedType.includes(obj)) {
            this.selectedType.splice(this.selectedType.indexOf(obj), 1);
          } else {
            this.selectedType.push(obj);
          }
        }}
        >
          {obj}
        </SwCheckbox>
        </div>
        )as VNode;
      })
    ) as VNode;
  }
  /* tslint:disable-next-line */
  accessScopeFilter(h: CreateElement): VNode   {// eslint-disable-line  // tslint:disable-line
    const scope: any = [];
    this.userList.map((obj:any) => {
      if (obj.accessScope && !scope.includes(obj.accessScope) && obj.accessScope !== '') {
        scope.push(obj.accessScope);
      }
    });
    const scopeData:any = [...scope];
    return (
      scopeData.map((obj:any) => {
        return (
        <div>
        <SwCheckbox name={'scope'}
        props-value={ obj }
        props-checked={this.selectedAccessScope.includes(obj)} with-margin
        on-change={() => {
          if (this.selectedAccessScope.includes(obj)) {
            this.selectedAccessScope.splice(this.selectedAccessScope.indexOf(obj), 1);
          } else {
            this.selectedAccessScope.push(obj);
          }
        }}
        >
          {obj}
        </SwCheckbox>
        </div>
        )as VNode;
      })
    ) as VNode;
  }
  /* tslint:disable-next-line */
  userGroupFilter(h: CreateElement): VNode   {// eslint-disable-line  // tslint:disable-line
    const group:any = [];
    this.userList.map((obj:any) => {
      if (!group.includes(obj.userGroupVal) && obj.userGroupVal) {
        group.push(obj.userGroupVal);
      }
    });
    const groupData:any = [...group];
    return (
      groupData.map((obj:any) => {
        return (
        <div>
        <SwCheckbox name={'userGroup'}
        props-value={ obj }
        props-checked={this.selectedGroup.includes(obj)} with-margin
        on-change={() => {
          if (this.selectedGroup.includes(obj)) {
            this.selectedGroup.splice(this.selectedGroup.indexOf(obj), 1);
          } else {
            this.selectedGroup.push(obj);
          }
        }}
        >
          {obj}
        </SwCheckbox>
        </div>
        )as VNode;
      })
    ) as VNode;
  }

  async onClear() {
    try {
      this.expandVisible = !this.expandVisible;
      this.$store.commit('startLoading');
      await this.getSelectedColumnList();
      await this.formatUserTableData();
      this.searchUserList = '';
      this.tempUserList = this.userTableData;
      this.selectedType = [];
      this.selectedAccessScope = [];
      this.selectedGroup = [];
      await this.fetchMsspPrefilterList();
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  startPendoAnalytics() {
    const currentUser : any = localStorage.getItem(currentUserKey);
    const userDetails = JSON.parse(currentUser) || '';
    if (userDetails !== '') {
      (window as any).pendo.initialize({
        visitor: {
          id: userDetails.userId || '',
          username: userDetails.userId || '', // For SFDC integ //
          org:  this.msspPrefilterResponseFromApi.content.orgName || '', // email domain //
          mssp: this.msspPrefilterResponseFromApi.content.MSSPTier || '', // MSSP tier //
        },
        account: {
          id: this.msspPrefilterResponseFromApi.content.orgID || '',  // OrgId for Company//
          name: this.msspPrefilterResponseFromApi.content.orgName || '', // Org Name
        },
      });
    }
  }
}
